import React, { Component } from 'react'
import { format } from 'date-fns'
import { List, Map } from 'immutable'
import { connect as connectRedux } from 'react-redux'
import Link from '../Link/index'
import { getBoundActions } from '../../actions/index'
import Sherpa, { TYPE_LARGE } from '../Sherpa/index'
import NotificationsWatchNow from '../NotificationsWatchNow/index'
import { NotificationsBell, BELL_TYPES } from '../NotificationsBell/index'
import { NOTIFICATION_TYPES, SUBSCRIPTION_TYPES } from '../../services/notifications/index'
import { rewriteCircleLink } from '../../services/notifications/circleLink'
import { buildCircleDrawerTo } from '../Community/Circles/CirclesNavEntry/useCircleDrawer'
import VerticalNavigation, { NOTIFICATIONS } from '../VerticalNavigation/index'
import { NotificationsFollowButton, BUTTON_TYPES } from '../NotificationsFollowButton/index'
import {
  PLAY_CLICK_GA4_EVENT,
  CLICK_TO_DETAILS_PAGE_GA4_EVENT,
} from '../../services/event-tracking/index'
import { H2, HEADING_TYPES } from '../Heading/index'
import { getAuthIsLoggedIn } from '../../services/auth/index'

function getGa4EventData (notification) {
  // GA4 events
  const series = notification.getIn(['node', 'series'], Map())

  let eventData = {
    notification_type: notification.get('type'),
    content_id: notification.get('contentId'),
    content_type: notification.get('contentType'),
    content_name: notification.getIn(['node', 'title']),
    media_id: notification.getIn(['node', 'feature', 'nid']),
    media_language: notification.getIn(['node', 'language']),
    is_featured_media: true,
    ui_location: 'Notifications List Page',
  }
  if (Map.isMap(series) && series.size > 0) {
    eventData = {
      ...eventData,
      parent_series_name: series.get('title'),
      parent_series_id: series.get('nid'),
    }
  }

  return eventData
}

function renderNewEpisode (notification) {
  const id = notification.get('id')
  const month = format(notification.get('startDate', ''), 'MMMM')
  const day = format(notification.get('startDate', ''), 'DD')
  const year = format(notification.get('startDate', ''), 'YYYY')
  const date = `${month} ${day}, ${year}`
  const label = notification.get('label', '')
  const imgUrl = notification.getIn(['node', 'keyart_16x9_withtext', 'keyart_304x171'], '')
  const path = notification.getIn(['node', 'path'], '')
  const title = notification.getIn(['node', 'title'], '')
  const seriesTitle = notification.getIn(['node', 'series', 'title'], '')
  const seriesPath = notification.getIn(['node', 'series', 'path'], '')

  // GA4 events
  const ga4EventData = getGa4EventData(notification)
  const ga4PlayClickEventData = PLAY_CLICK_GA4_EVENT.mergeDeep({
    ...ga4EventData,
    ui_element: 'Notification',
  })
  const ga4TitleClickEventData = CLICK_TO_DETAILS_PAGE_GA4_EVENT.mergeDeep({
    ...ga4EventData,
    ui_element: 'Title',
  })
  const ga4ThumbnailClickEventData = CLICK_TO_DETAILS_PAGE_GA4_EVENT.mergeDeep({
    ...ga4EventData,
    ui_element: 'Thumbnail',
  })

  return (
    <li className="notif-center__item" key={id}>
      <Link
        className="notif-center__item-hero"
        to={path}
        data-id={id}
        ga4EventData={ga4ThumbnailClickEventData}
      >
        <img className="notif-center__item-img" src={imgUrl} alt="" />
      </Link>
      <div className="notif-center__item-body">
        <div className="notif-center__item-label-wrapper">
          <div className="notif-center__item-label">
            {label}
          </div>
        </div>
        <div className="notif-center__item-context">
          <Link
            to={seriesPath}
            data-id={id}
            ga4EventData={ga4TitleClickEventData}
          >
            {seriesTitle}
          </Link>
        </div>
        <div className="notif-center__item-message">
          <Link
            className="notif-center__item-series"
            to={path}
            data-id={id}
            ga4EventData={ga4TitleClickEventData}
          >
            {title}
          </Link>
        </div>
        <div className="notif-center__item-date">
          {date}
        </div>
        <Link
          className="notif-center__item-watch"
          to={`${path}?fullplayer=feature`}
          data-id={id}
          ga4EventData={ga4PlayClickEventData}
        >
          <NotificationsWatchNow />
        </Link>
      </div>
    </li>
  )
}

function renderFreeForm (notification) {
  const id = notification.get('id')
  const month = format(notification.get('startDate', ''), 'MMMM')
  const day = format(notification.get('startDate', ''), 'DD')
  const year = format(notification.get('startDate', ''), 'YYYY')
  const date = `${month} ${day}, ${year}`
  const message = notification.get('message', '')
  const links = notification.get('links', List())
  const webLink = links.find((link) => link.get('type') === 'WEB')
  const webTarget = webLink && webLink.get('external') ? '_blank' : '_self'
  const imgUrl = notification.getIn(['node', 'keyart_16x9_withtext', 'keyart_304x171'], '')
  const path = notification.getIn(['node', 'path'], '')
  const reason = notification.get('reason')
  const label = notification.get('label')
  const ga4EventData = CLICK_TO_DETAILS_PAGE_GA4_EVENT.mergeDeep(
    getGa4EventData(notification),
  )

  return (
    <li className="notif-center__item" key={id}>
      {imgUrl ? (
        <Link className="notif-center__item-hero" to={path} data-id={id} ga4EventData={ga4EventData}>
          <img className="notif-center__item-img" src={imgUrl} alt="" />
        </Link>
      ) : (
        <div className="notif-center__item-bell">
          <NotificationsBell
            type={BELL_TYPES.STROKE_HEAVY}
            fill="#44576B"
            size={50}
          />
        </div>
      )}
      <div className="notif-center__item-body">
        {label && !imgUrl ? (
          <div className="notifications-menu__item-label">
            {label}
          </div>
        ) : null}
        {imgUrl ? (
          <div className="notifications-menu__item-context">
            {reason}
          </div>
        ) : null}
        <div className="notif-center__item-message">
          {webLink ? <Link to={webLink.get('path')} data-id={id} target={webTarget} ga4EventData={ga4EventData}>{message}</Link> : message }
        </div>
        <div className="notif-center__item-date">
          {date}
        </div>
      </div>
    </li>
  )
}

function renderRecommendation (notification) {
  const id = notification.get('id')
  const month = format(notification.get('startDate', ''), 'MMMM')
  const day = format(notification.get('startDate', ''), 'DD')
  const year = format(notification.get('startDate', ''), 'YYYY')
  const date = `${month} ${day}, ${year}`
  const label = notification.get('label', '')
  const imgUrl = notification.getIn(['node', 'keyart_16x9_withtext', 'keyart_304x171'], '')
  const path = notification.getIn(['node', 'path'], '')
  const title = notification.getIn(['node', 'title'], '')
  const type = notification.getIn(['node', 'type'])

  // GA4 events
  const ga4EventData = getGa4EventData(notification)
  const ga4PlayClickEventData = PLAY_CLICK_GA4_EVENT.mergeDeep({
    ...ga4EventData,
    ui_element: 'Notification',
  })
  const ga4TitleClickEventData = CLICK_TO_DETAILS_PAGE_GA4_EVENT.mergeDeep({
    ...ga4EventData,
    ui_element: 'Title',
  })

  return (
    <li className="notif-center__item" key={id}>
      <Link
        className="notif-center__item-hero"
        to={path}
        data-id={id}
        ga4EventData={ga4TitleClickEventData}
      >
        <img className="notif-center__item-img" src={imgUrl} alt="" />
      </Link>
      <div className="notif-center__item-body">
        <div className="notif-center__item-context">
          {label}
        </div>
        <div className="notif-center__item-message">
          <Link
            to={path}
            data-id={id}
            ga4EventData={ga4TitleClickEventData}
          >
            {title}
          </Link>
        </div>
        <div className="notif-center__item-date">
          {date}
        </div>
        {type === 'product_series' ? (
          <NotificationsFollowButton
            type={BUTTON_TYPES.PRIMARY_SMALL}
            contentId={notification.get('contentId')}
            subscriptionType={SUBSCRIPTION_TYPES.SERIES}
            uiLocation={'Notification List Page'}
          />
        ) : null}
        {type !== 'product_series' ? (
          <Link
            className="notifications-menu__item-watch"
            to={`${path}?fullplayer=feature`}
            data-id={id}
            ga4EventData={ga4PlayClickEventData}
          >
            <NotificationsWatchNow />
          </Link>
        ) : null}
      </div>
    </li>
  )
}

function renderFollow (notification) {
  const id = notification.get('id')
  const month = format(notification.get('startDate', ''), 'MMMM')
  const day = format(notification.get('startDate', ''), 'DD')
  const year = format(notification.get('startDate', ''), 'YYYY')
  const date = `${month} ${day}, ${year}`
  const imgUrl = notification.getIn(['member', 'image'], '')
  const title = notification.getIn(['member', 'title'], '')
  const url = notification.getIn(['member', 'url'], '')
  const type = notification.getIn(['node', 'type'])
  const label = notification.get('label', '')
  const image = imgUrl ? (
    <img
      className="notif-center__item-img"
      alt={title}
      src={imgUrl}
    />
  ) : null

  return (
    <li className="notif-center__item notif-center__item--member" key={id}>
      {url ? (
        <Link
          className={imgUrl ? 'notif-center__item-hero' : 'notif-center__item-hero notif-center__no-avatar'}
          to={url}
          data-id={id}
        >
          {image}
        </Link>
      ) : (
        <div className={imgUrl ? 'notif-center__item-hero' : 'notif-center__item-hero notif-center__no-avatar'} >
          {image}
        </div>
      )}
      <div className="notif-center__item-body">
        <div className="notifications-menu__item-label">
          {label}
        </div>
        <div className="notif-center__item-message">
          {url ? (
            <Link to={url} data-id={id}>
              {title}
            </Link>
          ) : (
            <span>{title}</span>
          )}
        </div>
        <div className="notif-center__item-date">
          {date}
        </div>
        {type === 'product_series' ? (
          <NotificationsFollowButton
            type={BUTTON_TYPES.PRIMARY_SMALL}
            contentId={notification.get('contentId')}
            subscriptionType={SUBSCRIPTION_TYPES.SERIES}
            uiLocation={'Notification List Page'}
          />
        ) : null}
      </div>
    </li>
  )
}

function renderNotifications ({
  notificationsProcessing = false,
  rows = List(),
  buildCircleTo = (uuid) => `/?circle=${uuid}`,
}) {
  if (notificationsProcessing) {
    return <Sherpa type={TYPE_LARGE} />
  }
  if (rows.isEmpty()) {
    return null
  }
  return rows.map((n = Map()) => {
    switch (n.get('type')) {
      case NOTIFICATION_TYPES.ACCOUNT_FOLLOWED:
      case NOTIFICATION_TYPES.MEMBER_FOLLOWING:
        return renderFollow(n)
      case NOTIFICATION_TYPES.SUBSCRIPTION_NEW_EPISODE:
      case NOTIFICATION_TYPES.SUBSCRIPTION_NEW_SEASON:
        return renderNewEpisode(n)
      case NOTIFICATION_TYPES.MEMBER_RECOMMENDATION:
      case NOTIFICATION_TYPES.SUBSCRIPTION_RECOMMENDATION:
      case NOTIFICATION_TYPES.GENERAL_RECOMMENDATION:
        return renderRecommendation(n)
      case NOTIFICATION_TYPES.MEMBER_FREE_FORM:
      case NOTIFICATION_TYPES.SUBSCRIPTION_FREE_FORM:
      case NOTIFICATION_TYPES.GENERAL_NEW_FEATURE:
      case NOTIFICATION_TYPES.GENERAL_FREE_FORM:
      case NOTIFICATION_TYPES.COMMENT_REJECTED:
      case NOTIFICATION_TYPES.CIRCLE_NEW_MESSAGE:
      case NOTIFICATION_TYPES.CIRCLE_OPENED:
      case NOTIFICATION_TYPES.CIRCLE_INVITE:
        // Circle mention / circle-opened / beta-2 invite: message + link. The
        // first two carry `?circle=` and get rewritten to open the drawer on
        // the current page; the invite's plain `/` link passes through
        // rewriteCircleLink untouched (the invitee is in no circle yet). The
        // free-form renderer draws the bell icon + linked message.
        return renderFreeForm(rewriteCircleLink(n, buildCircleTo))
      default:
        return null
    }
  })
}

function renderPaginationTotals (notifications, processing, staticText) {
  const p = notifications.get('p', 1)
  const pp = notifications.get('pp', 10)
  const total = notifications.get('total', 10)
  const rows = notifications.get('rows', List())

  if (processing || rows.size < 1) {
    return null
  }

  const start = p > 1 ? (p * pp) + 1 : 1
  const end = total < pp ? total : pp
  const showing = staticText.getIn(['data', 'showing'])
  const of = staticText.getIn(['data', 'of'])

  return `${showing} ${start}-${end} ${of} ${total}`
}

class NotificationsCenterAll extends Component {
  //
  componentDidMount () {
    const { props } = this
    const { auth, getNotifications } = props
    if (getAuthIsLoggedIn(auth)) {
      getNotifications()
    }
  }

  componentDidUpdate (prevProps) {
    const { props } = this
    const {
      auth,
      userLanguage,
      getNotifications,
    } = props
    const { userLanguage: prevUserLanguage } = prevProps

    if (userLanguage !== prevUserLanguage && getAuthIsLoggedIn(auth)) {
      getNotifications()
    }
  }

  componentWillUnmount () {
    const { props } = this
    const { auth, clearNotifications } = props
    if (getAuthIsLoggedIn(auth)) {
      clearNotifications()
    }
  }

  render () {
    const { props } = this
    const {
      auth,
      location,
      processing,
      staticText,
      notifications,
      query,
    } = props

    if (!getAuthIsLoggedIn(auth)) {
      return null
    }

    notifications.isEmpty()
    const rows = notifications.get('rows', List())
    // Open the circles drawer on THIS page (the /notifications route) rather than
    // routing to home — same overlay-on-current-page pattern as the bell.
    const buildCircleTo = (circleUuid) => buildCircleDrawerTo(
      (location && location.pathname) || '/',
      query && query.toJS ? query.toJS() : {},
      circleUuid,
    )

    return (
      <div className="notif-center__grid notif-center">
        <VerticalNavigation location={location} navType={NOTIFICATIONS} />
        <div className="notif-center__content-box notif-center__main">
          <H2 as={HEADING_TYPES.H4} className="notif-center__header">
            {staticText.getIn(['data', 'allNotifications'])}
          </H2>
          <div className="notif-center__pagination-title">
            {renderPaginationTotals(notifications, processing, staticText)}
          </div>
          <ul className="notif-center__list">
            {renderNotifications({
              rows, processing, buildCircleTo,
            })}
          </ul>
        </div>
      </div>
    )
  }
}

export default connectRedux(
  (state) => ({
    auth: state.auth,
    userLanguage: state.user.getIn(['data', 'language', 0], 'en'),
    processing: state.notifications.getIn(['user', 'processing']),
    notifications: state.notifications.getIn(['user', 'data'], Map()),
    query: state.resolver.get('query'),
    staticText: state.staticText.getIn(['data', 'notificationsCenterAll'], Map()),
    staticTextMenu: state.staticText.getIn(['data', 'notificationsMenu'], Map()),
    isWebView: state.app.get('isWebView', false),
  }),
  (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      getNotifications: actions.notifications.getNotifications,
      clearNotifications: actions.notifications.clearNotifications,
    }
  },
)(NotificationsCenterAll)
